import PrimaryCard from "./PrimaryCard";

export default PrimaryCard;
